import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PersonaInfo } from '../../utils/personaUtils';
import {
  PersonaCard,
  PersonaHeader,
  PersonaIcon,
  PersonaInfoSection,
  PersonaName,
  PersonaTagline,
  PersonaStats,
  StatItem,
  StatValue,
  StatLabel,
  JoinButton,
  UserPersonaBadge,
} from '../../styles/CommunityChatRooms/PersonaChatRoomCard.styles';

interface PersonaChatRoomCardProps {
  persona: PersonaInfo;
  isUserPersona?: boolean;
  memberCount: number;
}

export const PersonaChatRoomCard: React.FC<PersonaChatRoomCardProps> = ({
  persona,
  isUserPersona = false,
  memberCount,
}) => {
  const navigate = useNavigate();

  const handleJoin = () => {
    navigate(`/community-chat-rooms/${persona.id}`);
  };

  return (
    <PersonaCard $isUserPersona={isUserPersona}>
      {isUserPersona && (
        <UserPersonaBadge>Your Persona</UserPersonaBadge>
      )}
      
      <PersonaHeader>
        <PersonaIcon>{persona.icon}</PersonaIcon>
        <PersonaInfoSection>
          <PersonaName>{persona.name}</PersonaName>
          <PersonaTagline>{persona.tagline}</PersonaTagline>
        </PersonaInfoSection>
      </PersonaHeader>

      <PersonaStats>
        <StatItem>
          <StatValue>{memberCount.toLocaleString()}</StatValue>
          <StatLabel>Members</StatLabel>
        </StatItem>
      </PersonaStats>

      <JoinButton onClick={handleJoin} $isUserPersona={isUserPersona}>
        {isUserPersona ? 'Enter Your Room' : 'Join Room'}
      </JoinButton>
    </PersonaCard>
  );
};

